type HotelWithAssociatedBenefits = {
  shouldAssociateBenefits?: boolean | string | null;
  associatedBenefits?: unknown[] | null;
};

export const hasActiveAssociatedBenefits = (
  hotel?: HotelWithAssociatedBenefits | null,
): boolean => {
  if (!hotel) return false;
  const isEnabled =
    hotel.shouldAssociateBenefits === true ||
    hotel.shouldAssociateBenefits === 'true';
  return isEnabled && (hotel.associatedBenefits?.length ?? 0) > 0;
};
